import SolutionDetails from './SolutionDetails';

export default SolutionDetails;
